__turbopack_context__.v({
  "black": "WWavwW_black",
  "button": "WWavwW_button",
  "disabled": "WWavwW_disabled",
  "hollow": "WWavwW_hollow",
  "olive100": "WWavwW_olive100",
  "teal10": "WWavwW_teal10",
  "teal100": "WWavwW_teal100",
  "warmStone": "WWavwW_warmStone",
});
